<div class="modal-content modal-content-right">
  <div class="modal-header">
    <h5 class="modal-title"><i class="fas fa-file-import"></i> Column Mapping</h5>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div *ngIf="busy" class="col-md-12 text-center">
    <img src="./assets/images/preloader.gif" />
  </div>
  <div *ngIf="!busy" class="modal-body">
    <div class="row">
      <div class="col-md-5">
        <h4>File Preview</h4>
        <table class="table table-bordered table-striped">
          <thead class="thead-dark">
            <tr>
              <th width="40%" scope="col">Column Name</th>
              <th width="60%" scope="col">Value</th>
            </tr>
          </thead>
            <tbody *ngIf="csvContent && csvContent[0]">
              <tr *ngFor="let headerLabel of csvContent[0] | keyvalue: originalOrder">
                <td style="word-break:break-all;"><strong>{{headerLabel.key}}</strong></td>
                <td style="word-break:break-all;">{{headerLabel.value}}</td>
              </tr>
            </tbody>
          </table>
        </div>

      <div class="col-md-7">
        <h4>Map</h4>
        <form *ngIf="myFormGroup" [formGroup]="myFormGroup" (ngSubmit)="onSubmit()">
          <table class="table table-bordered">
              <thead class="thead-light">
                <tr>
                  <th width="30%" scope="col" (click)="sortTable('label', isSortedValue)">System Fields <i class="fa fa-fw fa-sort"></i></th>
                  <th width="38%" scope="col">Columns From CSV File</th>
                  <th width="12%" scope="col" (click)="sortTable('isRequired', isSortedValue)"><small>Required <i class="fa fa-fw fa-sort"></i></small></th>
                  <th width="10%" scope="col"><small>Value</small></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let form_elem of form_template; let ival = index;">
                  <td>{{form_elem.label}}</td>
                  <td>
                    <div class="form-group">
                      <select #dbList class="form-control" formControlName="{{form_elem.name}}" (change)="onOptionsSelected($event, form_elem.label)" [required]="form_elem.isRequired">
                        <option selected="selected" value=""></option>
                        <option *ngFor="let opt of form_elem.options; let i=index;" id="{{opt}}" value="{{opt}}">{{opt}}&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp;&nbsp;{{csvContent[0][opt]}}</option>
                      </select>
                    </div>
                  </td>
                  <td *ngIf="form_elem.label != 'DatePaid'" align="center"><div *ngIf="form_elem.isRequired == true"><span style="color:red;font-size:24px;text-align: center;">*</span></div></td><!--&& form_elem.isRequired == true-->
                  <td *ngIf="form_elem.label == 'DatePaid'" align="center">
                    <div *ngIf="isPaid == true"><span style="color:red;font-size:24px;text-align: center;">*</span></div>
                    <div *ngIf="isPaid == false"></div>
                  </td>
                  <td align="center"><div *ngIf="dbList.selectedIndex != ''"><span style="color:green;font-size:18px;"><i class="fa fa-check-circle" aria-hidden="true"></i></span></div></td>
                </tr>
              </tbody>
            </table>
          </form>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-outline"
      (click)="save()"
      [disabled]="myFormGroup.status === 'INVALID'"      
    >Save Mapped Columns</button>
  </div>
</div>
